import * as Api from '../../api';
import Utils from '../../untils';
import Vue from 'vue'
const state = {
  };

const getters = {
};

const mutations = {
};

const actions = {
    logOut ({state, rootState}, {pat, callback}) {  //登出
        let obj = {
            action: '/oa/admin/logout',
        };
        Vue.http.headers.common = {token:state.token?state.token:Utils.loadLocal2('token')}
        Api.requestbodys(obj).then((resp) => {
          if (callback) {
            callback(resp, 'logOut')
          }
        })
    },

    getSetupList ({state, rootState}, {pat, callback}) {  //第三方列表
        let obj = {
            action: '/oa/setup/setupList',
        };
        Vue.http.headers.common = {token:state.token?state.token:Utils.loadLocal2('token')}
        Api.requestbodys(obj).then((resp) => {
          if (callback) {
            callback(resp, 'getSetupList')
          }
        })
    },

    setSetupUrl ({state, rootState}, {pat, callback}) {  //第三方列表设置
        let obj = {
            action: '/oa/setup/setup',
            setId:pat.setId,
            url:pat.url
        };
        Vue.http.headers.common = {token:state.token?state.token:Utils.loadLocal2('token')}
        Api.requestput(obj).then((resp) => {
          if (callback) {
            callback(resp, 'setSetupUrl')
          }
        })
    },

    // 用户佣金模块
    getCommissionLists ({state, rootState}, {pat, callback}) {  //获取佣金列表
        let obj = {
            action: `/oa/commission/${pat.userId}/${pat.beginTime}/${pat.endTime}/${pat.page}/${pat.size}`,
            keyWord:pat.keyWord
        };
        Vue.http.headers.common = {token:state.token?state.token:Utils.loadLocal2('token')}
        Api.requestbody(obj).then((resp) => {
          if (callback) {
            callback(resp, 'getCommissionLists')
          }
        })
    },

    getBonusLists ({state, rootState}, {pat, callback}) {  //获取奖金列表
        let obj = {
            action: `/oa/bonus/${pat.userId}/${pat.beginTime}/${pat.endTime}/${pat.page}/${pat.size}`,
            keyWord:pat.keyWord
        };
        Vue.http.headers.common = {token:state.token?state.token:Utils.loadLocal2('token')}
        Api.requestbody(obj).then((resp) => {
          if (callback) {
            callback(resp, 'getBonusLists')
          }
        })
    },

    changeCommissionPaidType ({state, rootState}, {pat, callback}) {  //修改佣金状态
        let obj = {
            action: `/oa/commission/${pat.ordersId}/${pat.commissionInvoiceStatus}`
        };
        Vue.http.headers.common = {token:state.token?state.token:Utils.loadLocal2('token')}
        Api.requestput(obj).then((resp) => {
          if (callback) {
            callback(resp, 'changeCommissionPaidType')
          }
        })
    },

    changeBonusPaidType ({state, rootState}, {pat, callback}) {  //修改奖金状态
        let obj = {
            action: `/oa/bonus/${pat.ordersId}/${pat.commissionInvoiceStatus}`
        };
        Vue.http.headers.common = {token:state.token?state.token:Utils.loadLocal2('token')}
        Api.requestput(obj).then((resp) => {
          if (callback) {
            callback(resp, 'changeBonusPaidType')
          }
        })
    },

    getCommissionsMonth ({state, rootState}, {pat, callback}) {  //佣金列表，按月
        let obj = {
            action: `/oa/commission/months/${pat.year}/${pat.userId}/${pat.page}/${pat.size}`
        };
        Vue.http.headers.common = {token:state.token?state.token:Utils.loadLocal2('token')}
        Api.requestget(obj).then((resp) => {
          if (callback) {
            callback(resp, 'getCommissionsMonth')
          }
        })
    },

    getCommissionsYear({state, rootState}, {pat, callback}) {  //佣金列表，按年
        let obj = {
            action: `/oa/commission/year/${pat.userId}/${pat.page}/${pat.size}`
        };
        Vue.http.headers.common = {token:state.token?state.token:Utils.loadLocal2('token')}
        Api.requestget(obj).then((resp) => {
          if (callback) {
            callback(resp, 'getCommissionsYear')
          }
        })
    },

    getTotalsMonth ({state, rootState}, {pat, callback}) {  //销售额列表，按月
        let obj = {
            action: `/oa/total/months/${pat.year}/${pat.userId}/${pat.page}/${pat.size}`
        };
        Vue.http.headers.common = {token:state.token?state.token:Utils.loadLocal2('token')}
        Api.requestget(obj).then((resp) => {
          if (callback) {
            callback(resp, 'getTotalsMonth')
          }
        })
    },

    getTotalsYear({state, rootState}, {pat, callback}) {  //销售额列表，按年
        let obj = {
            action: `/oa/total/year/${pat.userId}/${pat.page}/${pat.size}`
        };
        Vue.http.headers.common = {token:state.token?state.token:Utils.loadLocal2('token')}
        Api.requestget(obj).then((resp) => {
          if (callback) {
            callback(resp, 'getTotalsYear')
          }
        })
    },

    // 用户售出房产
    getSoldHouseList({state, rootState}, {pat, callback}) {  //售出房产
        let obj = {
            action: `/oa/orders/sold/${pat.userId}/${pat.beginTime}/${pat.endTime}/${pat.page}/${pat.size}`,
            keyWord:pat.keyWord
        };
        Vue.http.headers.common = {token:state.token?state.token:Utils.loadLocal2('token')}
        Api.requestbody(obj).then((resp) => {
          if (callback) {
            callback(resp, 'getSoldHouseList')
          }
        })
    },

    uconnectToAgent({state, rootState},{pat,callback}){//添加房源
      let obj={
        action:`/api/agent/uconnect-to-agent/${pat.id}`,
        ...pat
      }
      console.log("uconnectToAgent: ", obj)
      Vue.http.headers.common = {webType:'store',token:state.token?state.token:Utils.loadLocal2('token')}
      Api.requestbody(obj).then((resp) => {
        if (callback) {
          callback(resp, 'uconnectToAgent')
        }
      })
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/stores.js